export default {
  lista: [],
  estaCarregando: false,
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionadoID: null,
  itemSelecionado: {
    id: null,
    apelido: null
    /*
    modalidade_turma: null,
    curso: null,
    sala_franqueada: null,
    horario: null,
    professor: null,
    descricao: null,
    maximo_alunos: null,
    data_inicio: undefined,
    excluido: false
    */
  }
}
